"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sortByOnMarket = void 0;
exports.sortByOnMarket = function (a, b) {
    if (!a.available && !b.available)
        return 0;
    if (a.available && b.available)
        return 0;
    return 1;
};
